var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDescriptionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5858 2.58579C14.2107 2.21071 13.702 2 13.1716 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8.82843C20 8.29799 19.7893 7.78929 19.4142 7.41421L14.5858 2.58579ZM18 19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19V5C6 4.44772 6.44772 4 7 4H12C12.5523 4 13 4.44772 13 5V8C13 8.55228 13.4477 9 14 9H17C17.5523 9 18 9.44772 18 10V19Z",
    fill: "#6860EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86816 16.0184C7.86816 15.6318 8.18156 15.3184 8.56816 15.3184H15.1682C15.5548 15.3184 15.8682 15.6318 15.8682 16.0184V16.6184C15.8682 17.005 15.5548 17.3184 15.1682 17.3184H8.56816C8.18156 17.3184 7.86816 17.005 7.86816 16.6184V16.0184Z",
    fill: "#6860EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86816 12.0184C7.86816 11.6318 8.18156 11.3184 8.56816 11.3184H15.1682C15.5548 11.3184 15.8682 11.6318 15.8682 12.0184V12.6184C15.8682 13.005 15.5548 13.3184 15.1682 13.3184H8.56816C8.18156 13.3184 7.86816 13.005 7.86816 12.6184V12.0184Z",
    fill: "#6860EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionIcon);
export default __webpack_public_path__ + "static/media/description-icon.824d441935bdcd3b1f6595fc98d7ca9c.svg";
export { ForwardRef as ReactComponent };